import React from 'react';

interface Props {
  data: {
    expectedCash?: number;
    totalSales?: number;
    cashCount?: {
      countedAmount?: number;
      difference?: number;
    } | null;
  };
}

/**
 * 🔻 Footer del Corte X (KPIs)
 */
const CashClosingXFooter: React.FC<Props> = ({ data }) => {
  const format = (value?: number) =>
    (value ?? 0).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });

  const difference = data.cashCount?.difference ?? 0;

  const differenceColor =
    difference === 0
      ? 'text-[#3CA745]'
      : difference > 0
      ? 'text-[#F9C107]'
      : 'text-[#DC3545]';

  return (
    <div className="border-t border-stroke dark:border-strokedark">
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4">
        {/* ITEM */}
        <div className="flex flex-col justify-center border-b border-stroke px-5 py-4 dark:border-strokedark xl:border-b-0 xl:border-r">
          <span className="text-gray-500 dark:text-gray-400 text-xs">
            Efectivo esperado
          </span>
          <p className="text-lg font-semibold text-black dark:text-white">
            {format(data.expectedCash)}
          </p>
        </div>

        {/* ITEM */}
        <div className="flex flex-col justify-center border-b border-stroke px-5 py-4 dark:border-strokedark xl:border-b-0 xl:border-r">
          <span className="text-gray-500 dark:text-gray-400 text-xs">
            Conteo físico
          </span>
          <p className="text-lg font-semibold text-black dark:text-white">
            {format(data.cashCount?.countedAmount)}
          </p>
        </div>

        {/* ITEM */}
        <div className="flex flex-col justify-center border-b border-stroke px-5 py-4 dark:border-strokedark xl:border-b-0 xl:border-r">
          <span className="text-gray-500 dark:text-gray-400 text-xs">
            Diferencia
          </span>
          <p className={`text-lg font-semibold ${differenceColor}`}>
            {format(difference)}
          </p>
        </div>

        {/* ITEM */}
        <div className="flex flex-col justify-center px-5 py-4">
          <span className="text-gray-500 dark:text-gray-400 text-xs">
            Total ventas
          </span>
          <p className="text-lg font-semibold text-success">
            {format(data.totalSales)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CashClosingXFooter;
